import React from 'react'
import { Link, useRouteMatch } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'
import { Box, FormHelperText } from '@material-ui/core'

import { useStore } from '../hooks/storeHook'

import { appRoutes } from '../common/appRoutes'

import { integrationKeyByType, StoreIntegrationType } from '../types/integrationTypeUtils'

export type AddStoreAccountButtonProps = {
  integration: StoreIntegrationType

  withHelpText?: boolean
}

export const AddStoreAccountButton =
  observer(
    ({withHelpText, integration}: AddStoreAccountButtonProps) => {
      const addUrl = appRoutes.Store.settings.makeUrl({accountId: 0, integration: integrationKeyByType[integration]})

      const isSelected = !!useRouteMatch(addUrl)

      const {canAddStoreAccount} = useStore()

      const classes = useStyles()

      return (
        <Box className={classes.root}>
          {
            canAddStoreAccount(integration) &&
            <Link className={classes.addLink} to={addUrl}>
              <div className={clsx('nav_account_add', isSelected && 'nav_account_add_selected')}>
                <p>Добавить</p>
                <p>+</p>
              </div>
            </Link>
          }

          {
            withHelpText &&
            <Box className={clsx(classes.hint, 'default-border')}>
              <FormHelperText className={classes.helperText}>
                Для того, чтобы добавить аккаунт маркетплейса, нажмите на кнопку выше и перейдите к этапу ввода
                API-токена.
              </FormHelperText>
            </Box>
          }
        </Box>
      )
    })

export const AddStoreAccountStub =
  () => {
    const classes = useStyles()

    return (
      <Box className={classes.root}>
        <Box className={clsx(classes.hint, 'default-border')}>
          <FormHelperText className={classes.helperText}>
            Для того, чтобы добавить аккаунт маркетплейса, выберите его вкладку выше.
          </FormHelperText>
        </Box>
      </Box>
    )
  }

const useStyles = makeStyles(
  () => ({
    root: {
      position: 'relative',
      width: 200
    },
    addLink: {
      textDecoration: 'none'
    },
    hint: {
      padding: 20,
      maxWidth: 160,
      position: 'absolute',
      backgroundColor: '#FBFBFD'
    },
    helperText: {
      fontSize: 11,
      fontWeight: 400,
      marginTop: 5
    }
  })
)